import { Tag } from 'react-tag-autocomplete';
import SurfaceExaminedHistory from './tract_detail/SurfaceExaminedHistory';
import Ownership from './tract_detail/Ownership';
import TractDetail from './tract_detail/TractDetail';
import Owner from './tract_detail/Owner';
import Abstract from './Abstract';

export default class {
    id: number;
    fieldId: number;
    name: string;
    acres: number;
    isPartial: boolean;
    partialAcreage: number;
    grantor: string;
    grantee: string;
    recordTypeId: number;
    book: string;
    page: string;
    recordDate: Date;
    boundByNorth: string;
    boundBySouth: string;
    boundByWest: string;
    boundByEast: string;
    legalDescription: string;
    number: number;
    instrumentTypeId: number;
    instrumentNumber: string;
    countyId: number;
    note: string;
    miscHyperlink: string;

    // ROW Line-specific fields
    rowLength: number;
    rowLengthUnit: string;
    lineListNumber: string;
    segmentNumber: string;
    breakdown: string;
    parcelId: string;
    taxParcelOther: string;
    latitude: string;
    longitude: string;
    mapNo: string;
    nfsNo: string;
    nfsName: string;
    ownershipType: string;
    isActive: boolean;
    createdBy: string;
    createdByUserId: number;
    createdDate: Date;
    modifiedBy: string;
    modifiedByUserId: number;
    modifiedDate: Date;

    fieldTractNumbers?: number[];
    ownerships: Array<Ownership>;
    tags: Array<Tag>;
    addTags?: Array<Tag>;
    deleteTags?: Array<Tag>;
    abstracts: Array<Abstract>;
    examinedHistories: Array<SurfaceExaminedHistory>;
    mineralTracts: Array<TractDetail>;
    owners: Array<Owner>;
}



// WEBPACK FOOTER //
// ./src/models/SurfaceTract.ts